import React from 'react';
import { Avatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { mediaUrl } from '@/lib/api';
import { cn } from '@/lib/utils';

function initials(name) {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/**
 * Avatar circolare riutilizzabile: mostra la foto del cliente (GridFS/social) o le iniziali.
 */
export function UserAvatar({ name, src, className, fallbackClassName, ...props }) {
  return (
    <Avatar className={cn('shrink-0', className)} {...props}>
      {src ? (
        <AvatarImage
          src={mediaUrl(src)}
          alt={name || 'Avatar'}
          className="object-cover"
          referrerPolicy="no-referrer"
        />
      ) : null}
      <AvatarFallback className={cn('bg-primary/10 font-medium text-primary', fallbackClassName)}>
        {initials(name)}
      </AvatarFallback>
    </Avatar>
  );
}
